import {Blog,Features,Footer,Header,Possibility,WhatGPT3} from '../container';
function InogestDisponibilidade(){
    return (
        <div className='App'>
      
        InogestDisponibilidade
        </div>
    )
}

export default InogestDisponibilidade
